import React, { memo } from 'react'
import { Stack, TableRow } from '@mui/material'

import HeaderWithIcon from '../shared/text/HeaderWithIcon'
import DataTable from '../shared/DataTable/DataTable'
import { formatTicks, toUpper } from '../../util/string.helpers'
import { formatEthCurrency } from '../../util/numbers.helpers'
import { truncateTextForHash } from '../../util/app.helpers'
import TableCellData from '../shared/DataTable/TableCellData'
import BadgeColumn from '../shared/DataTable/BadgeColumn'
import CustomTooltip from '../shared/customTooltip/CustomTooltip'

const RankingsTable = ({ title, icon, headers, data, invertBadge }) => {
  return (
    <Stack spacing={1.125} sx={{ overflow: 'hidden' }}>
      <HeaderWithIcon label={title} icon={icon} />
      <DataTable
        headers={headers.map((header) => ({ label: header }))}
        data={data.map((props, index) => (
          <DataTableRow
            key={index}
            invertBadge={invertBadge}
            rank={index + 1}
            {...props}
          />
        ))}
      />
    </Stack>
  )
}

export default memo(RankingsTable)

const DataTableRow = ({ rank, w, c, e, p, invertBadge, additional }) => {
  const badge = w ? w.slice(-2) : toUpper(c[0])
  return (
    <TableRow>
      <BadgeColumn badge={badge} invert={invertBadge} />
      <TableCellData textProps={{ fontWeight: 700 }}>{rank}</TableCellData>
      <TableCellData>
        <CustomTooltip label={w}>
          {w ? truncateTextForHash(w) : c}
        </CustomTooltip>
      </TableCellData>
      <TableCellData>{formatEthCurrency(e)}</TableCellData>
      <TableCellData>{formatTicks(p)}</TableCellData>
      {additional &&
        Object.keys(additional).map((prop, index) => (
          <TableCellData key={index}>{additional[prop]}</TableCellData>
        ))}
    </TableRow>
  )
}
